import { map, get } from 'lodash';
import {
  HOLDOUT,
  COMMITTED,
} from './membership-statuses';
import {
  CAPTURED,
} from './contribution-statuses';
import {
  ORGANIZER,
} from './membership-roles';
import money, { Money, USD } from './money';

const calculateRefund = (contributionSchedule, totalAmount) => {
  return Money.subtract(paidToDate(contributionSchedule), money(totalAmount));
};

const getPaidContributions = (contributions) => {
  if (!contributions) return [];

  return contributions.filter(contribution => (
    contribution.status === CAPTURED
  ));
};

const getRefund = (shareAmount, contributionSchedule) => {
  const { currencyCode } = shareAmount;
  const paidAmount = paidToDate(contributionSchedule, currencyCode);
  if (getsRefund(money(shareAmount), contributionSchedule)) {
    return Money.subtract(paidAmount, money(shareAmount));
  }
  return Money.zero(currencyCode);
};

const getsRefund = (shareAmount, contributionSchedule) => {
  const { currencyCode } = shareAmount;
  const paidAmount = paidToDate(contributionSchedule, currencyCode);
  return paidAmount.isGreaterThan(money(shareAmount));
};

const paidToDate = (contributionSchedule, defaultCurrency = USD) => {
  const amounts = map(
    getPaidContributions(contributionSchedule),
    'shareAmount'
  ).map(money);
  return Money.sum(amounts, defaultCurrency);
};

const isCommitted = status => status === COMMITTED;

const isHoldout = status => status === HOLDOUT;

const isOrganizer = role => role === ORGANIZER;

const defaultContributionAmount = ({ membership, minContribution, currencyCode }) => {
  const allowed = money(get(membership, 'allowedShareAmount'));
  const min = money(minContribution);
  const currency = currencyCode || get(min, 'currencyCode') || get(allowed, 'allowedShareAmount');

  if (!allowed && !min) return Money.zero(currency);
  if (!allowed) return min;
  if (!min) return allowed;
  if (allowed.isLessThan(min)) return min;

  return allowed;
};

const mergeWithProjection = (memberships, projections) => {
  if (!projections || !Object.keys(projections).length) return [];
  return memberships.map(m => {
    const projected = get(projections, m.id, {});
    return { ...m, ...projected };
  });
};

export default {
  calculateRefund,
  getRefund,
  getsRefund,
  getPaidContributions,
  mergeWithProjection,
  paidToDate,
  isHoldout,
  isCommitted,
  isOrganizer,
  defaultContributionAmount,
};



// WEBPACK FOOTER //
// ./src/lib/membership.js